import { createJSONStorage } from "zustand/middleware";
import { createStore } from ".";
import { v4 as uuidv4 } from "uuid";
import type { ModalKey } from "../constants/modal.constants";

export type ModalItem<T = unknown> = {
  id: string;
  key: ModalKey;
  props?: Omit<T, keyof ModalComponentProps>;
};

type ModalState = {
  modals: ModalItem[];
  hasHydrated: boolean;
  setHasHydrated: (v: boolean) => void;
  openModal: <T>(key: ModalKey, props?: ModalItem<T>["props"]) => string;
  closeModal: (id: string) => void;
  clearModal: () => void;
};

export const useModalStore = createStore<ModalState>(
  (set) => ({
    modals: [],
    hasHydrated: false,
    setHasHydrated: (v) => set(() => ({ hasHydrated: v })),
    openModal: (key, props) => {
      const id = uuidv4();
      const modal = { id, key, props };
      set((state) => ({ modals: [...state.modals, modal] }));
      return id;
    },
    closeModal: (id) =>
      set((state) => ({
        modals: state.modals.filter((m: ModalItem) => m.id !== id),
      })),
    clearModal: () => set(() => ({ modals: []}))
  }),
  {
    name: "modals",
    storage: createJSONStorage(() => sessionStorage),
    partialize: (state) => ({ ...state, modals: [] }),
    onRehydrateStorage: () => (state) => {
      state?.clearModal();
      state?.setHasHydrated(true);
    }
  }
);
